/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.25.1
 */

import styled from 'styled-components';

export const PageNewsPreviewContolsStyled = styled.div`
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
    & > :not(:last-child) {
        margin-right: 24px;
    }
`;
